import React from "react"
import { Text, Logo } from "src/components/help-center-section/styled-compnent"

import styled from "styled-components"
import colors from "src/theme/colors"

type Props = {
  subTitle?: string
  title?: string
}

export const HelpInfo = styled.div<any>`
  display: flex;
  margin-top: 5px;
  align-items: center;
`

export const HelpLeft = styled.div<any>`
  margin-left: 6px;
`

const HelpCollection = (props: Props) => {
  const { subTitle = "Written by Tolobi Team", title = "10 articles in this collection" } = props
  return (
    <>
      <HelpInfo>
        <Logo width={"35px"} height={"35px"} />
        <HelpLeft>
          <Text fontSize={15} fontWeight={300} color={colors.black}>
            {title}
          </Text>
          <Text fontSize={14} fontWeight={300} color={"#8F919D"}>
            {subTitle}
          </Text>
        </HelpLeft>
      </HelpInfo>
    </>
  )
}

export default HelpCollection
